import React from 'react';
import './toggleButton.scss';
const ToggleButton = ({flag, id, item, callBack}) => {
  return (<>
          <input className='input-switch' type="checkbox" checked={flag? true: false} id="demo" name="toggle"/>
          <label class="label-switch" for="demo" onClick={(event)=>{
            callBack(item.id, item.active)
          }}></label>
          <span class="info-text"></span>
        </>)
}

export default ToggleButton;

